import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable()
export class EnvironmentService {
  private host: string = environment.host;
  private port: string = environment.port;

  getBaseURL(): string {
    return this.host + ":" + this.port;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/environment.service.ts